import React from 'react';
import { ISelectionType } from 'src/components/10-atoms/form/inputs/SelectInput/types';
import SelectInputItem from 'src/components/10-atoms/form/inputs/select-input-group/SelectInputItem';
import BottomDrawerLayout from 'src/components/20-helper-views/bottom-drawer/BottomDrawerLayout';
import useTheme from 'src/customizations/themes/hooks/useTheme';
import createThemedStyle from 'src/customizations/themes/utils/createThemedStyles';
import GQLPaginatedList from 'src/lib/graphql/components/GQLPaginatedList';
import useI18n from 'src/modules/translations/hooks/useI18n';
import ListEmpty from './ListEmpty';
import ListLoader from './ListLoader';
import useData from './useData';
import styleUtils from 'src/utils/styles';
const SelectCommunityDrawer = ({ value, onChange, }) => {
    const [{}] = useTheme(stylesGenerator);
    const { translate } = useI18n();
    const [state, actions] = useData();
    return (React.createElement(BottomDrawerLayout, { yAxis: "flex-start", style: styleUtils.containerHeight },
        React.createElement(BottomDrawerLayout.Title, null, translate('Select Exam Community')),
        React.createElement(GQLPaginatedList, { disableSAB: true, LoaderComponent: ListLoader, ListEmptyComponent: ListEmpty, queryState: state.listQuery, queryActions: actions.listQuery, variables: state.listQueryVariables, renderItem: ({ item: community }) => (React.createElement(SelectInputItem, { type: ISelectionType.SINGLE, isSelected: community.id === value?.id, title: community.data.title, onPress: () => onChange(community) })), containerStyle: { flex: 1 } })));
};
const stylesGenerator = createThemedStyle(({ theme }) => ({}));
export default SelectCommunityDrawer;
